import React from 'react'
import PropTypes from 'prop-types'

import { Image } from 'semantic-ui-react'
import { Link } from 'react-router'

import { FAMILY_ALBUM_URL } from 'Global/constants'

import * as styles from './styles'

const FAEventCardPicture = ({ event }) => {
  return (
    <Link to={`/familyAlbum/${event.id}`}>
      <div style={styles.background}>
        <Image src={`${FAMILY_ALBUM_URL}/${event.logo}`} fluid />
      </div>
    </Link>
  )
}

FAEventCardPicture.propTypes = {
  event: PropTypes.object.isRequired,
}

export default FAEventCardPicture
